import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=450a5168&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=450a5168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a5168",
  null
  
)

export default component.exports